import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Input,
  Select,
  Segmented,
  Typography,
  Button,
  Form,
  message,
  Spin,
  Popconfirm,
  List,
  Space,
  Empty,
  Tag,
  Avatar,
  Tooltip,
} from 'antd';
import { VideosPageWrapper } from './styled';
import {
  CustomTitle,
  CustomSubTitle,
  CustomButton,
  CustomSecondaryButton,
  PhysicianPageWrapper,
} from '../physician_page/styled';
import {
  SearchOutlined,
  PlayCircleOutlined,
  SaveOutlined,
  FileTextOutlined,
  EditOutlined,
  RobotOutlined,
  DeleteOutlined,
  EyeOutlined,
  UserOutlined,
  TeamOutlined,
  CloseOutlined,
  PlusOutlined,
} from "@ant-design/icons";


import { debounce, notify } from "../../../utils/helper";
import VideosPlayer from './VideosPlayer';
import VideoModal from '../../modal/VideoModal';
import VideoContainer from '../videos_container/VideoContainer';
import videoService from '../../../services/videos';
import ScriptsPage from "../scripts_page/ScriptsPage";
import { SpecilityContext } from "../../../context/SpecilityContext";

const { Title, Text, Paragraph } = Typography;

const duration = [
  {
    value: 'Any Duration',
    label: 'Any Duration',
  },
  {
    label: 'Under 5 minutes',
    value: 'Under 5 minutes',
  },
  {
    label: '5-15 minutes',
    value: '5-15 minutes',
  },
  {
    label: 'Over 15 minutes',
    value: 'Over 15 minutes',
  },
];

const videoType = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'Master',
    value: 'master',
  },
  {
    label: 'AI Enhanced',
    value: 'ai enhanced',
  },
  {
    label: 'Patient Education',
    value: 'patient education',
  },
  {
    label: 'CCM',
    value: 'ccm',
  },
];


const FilterSidebar = React.memo(function FilterSidebar({
  searchText,
  setSearchText,
  handleSearchChange,
  selectedSpecialty,
  handleSpecialtyChange,
  specialtyOptions,
  selectedType,
  handleTypeChange,
  videoType,
  selectedDuration,
  handleDurationChange,
  duration,
  handleApplyFilters,
  loading
}) {
  return (
    <Col span={6}>
      <div style={{
        position: 'sticky',
        top: '20px',
        height: 'calc(100vh - 140px)',
        overflowY: 'auto'
      }}>
        <Card className="mb-15 custom-filter-card">
        <Col>
          <h3 className="font-24 text-primary">Filters</h3>
        </Col>
        <Col className="mb-24">
          <div className="mb-5 font-16 font-semibold text-primary">Search</div>
          <div className="row-flex">
            <Input
              placeholder="Search Videos..."
              className="pr-40"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                handleSearchChange(e.target.value);
              }}
            />
            <SearchOutlined className="videopage-search-icon font-19" />
          </div>
        </Col>
        <Col className="mb-24">
          <div className="mb-5 font-16 font-semibold text-primary">
            Specialty
          </div>
          <div>
            <Select
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              showSearch
              style={{ width: '100%' }}
              dropdownStyle={{ maxHeight: 200, overflowY: 'auto', overflowX: 'hidden' }}
              listHeight={160}
              className="w-100"
              value={selectedSpecialty}
              onChange={handleSpecialtyChange}
              options={[
                {label: 'All Specialties', value: 'All'},
                ...specialtyOptions]}
            />
          </div>
        </Col>
        <Col className="mb-24">
          <div className="mb-5 font-16 font-semibold text-primary">
            Video Type
          </div>
          <div>
            <Select
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              showSearch
              style={{ width: '100%' }}
              dropdownStyle={{ maxHeight: 200, overflowY: 'auto', overflowX: 'hidden' }}
              listHeight={160}
              className="w-100"
              value={selectedType}
              onChange={handleTypeChange}
              options={videoType}
            />
          </div>
        </Col>
        <Col className="mb-24">
          <div className="mb-5 font-16 font-semibold text-primary">
            Duration
          </div>
          <div>
            <Select
              className="w-100"
              value={selectedDuration}
              onChange={handleDurationChange}
              options={duration}
            />
          </div>
        </Col>
        <Col>
          <CustomButton
            className="w-100"
            onClick={handleApplyFilters}
            loading={loading}
          >
            Apply Filters
          </CustomButton>
        </Col>
      </Card>
      </div>
    </Col>
  );
});


function VideosSection({
  allVideos,
  videos,
  hasMoreVideos,
  handleLoadMore,
  loadMoreLoading,
  loading
}) {
  return (
    <Col span={18}>
        {allVideos?.length > 0 ? (
          <>
            <VideoContainer videos={{ ...videos, results: allVideos }} />
            {hasMoreVideos && (
              <Col className="mt-25 w-100 d-flex justify-content-center" style={{ padding: '20px 0' }}>
                <CustomSecondaryButton onClick={handleLoadMore} loading={loadMoreLoading}>
                  Load More Videos
                </CustomSecondaryButton>
              </Col>
            )}
            {!hasMoreVideos && allVideos.length > 0 && (
              <Col className="mt-25 w-100 d-flex justify-content-center" style={{ padding: '20px 0' }}>
                <p style={{ color: '#666', fontStyle: 'italic' }}>No more videos to load</p>
              </Col>
            )}
          </>
        ) : loading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '400px',
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <Card
            className="empty-state-card"
            style={{
              textAlign: 'center',
              padding: '60px',
              marginTop: '20px',
              height: '500px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Col>
              <PlayCircleOutlined
                style={{
                  fontSize: '80px',
                  color: 'var(--secondary-text-color)',
                  marginBottom: '20px',
                }}
              />
              <h2
                style={{
                  color: 'var(--primary-text-color)',
                  marginBottom: '10px',
                  fontSize: '24px',
                  fontWeight: 600,
                }}
              >
                No Videos Available
              </h2>
              <p
                style={{
                  color: 'var(--secondary-text-color)',
                  fontSize: '16px',
                  maxWidth: '400px',
                  margin: '0 auto 30px',
                }}
              >
                There are currently no videos in our library. Please check back
                later or try adjusting your filters.
              </p>
            </Col>
          </Card>
        )}
    </Col>
  );
}

const VideosPage = () => {
  const [activeTab, setActiveTab] = useState('Videos');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videos, setVideos] = useState([]);
  const [allVideos, setAllVideos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadMoreLoading, setLoadMoreLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(9);
  const [hasMoreVideos, setHasMoreVideos] = useState(true);
  const { specialtyOptions } = useContext(SpecilityContext);

  
  const [searchText, setSearchText] = useState('');
  const [selectedSpecialty, setSelectedSpecialty] = useState('All Specialties');
  const [selectedDuration, setSelectedDuration] = useState('Any Duration');
  const [selectedType, setSelectedType] = useState('All');

  const getDurationInSeconds = (durationText) => {
    switch (durationText) {
      case 'Under 5 minutes':
        return 'under5';
      case '5-15 minutes':
        return '5to15';
      case 'Over 15 minutes':
        return 'over15';
      case 'Any Duration':
      default:
        return '';
    }
  };

  const getAllVideos = useCallback(async (page = 1, searchInput = '', isLoadMore = false) => {
    if (isLoadMore) {
      setLoadMoreLoading(true);
    } else {
      setLoading(true);
    }
    
    try {
      const specialty =
        (selectedSpecialty === 'All Specialties' ||
          selectedSpecialty === 'All') ? [] : selectedSpecialty;

      const durationSeconds = getDurationInSeconds(selectedDuration);

      const videoType = selectedType === "all" ? '' : selectedType;

      const response = await videoService.getVideos(
        pageSize, 
        page,
        "",
        searchInput,
        JSON.stringify(specialty),
        videoType,
        durationSeconds,
        ""
      );
      
      const newVideos = response?.data?.videos?.results || [];
      
      if (isLoadMore) {
        setAllVideos(prevVideos => [...prevVideos, ...newVideos]);
        setVideos(response?.data?.videos);
      } else {
        setAllVideos(newVideos);
        setVideos(response?.data?.videos);
      }
      
     
      setHasMoreVideos(newVideos.length === pageSize);
      
      setCurrentPage(page);
      
    } catch (error) {
      console.error('Error fetching videos:', error);
    } finally {
      if (isLoadMore) {
        setLoadMoreLoading(false);
      } else {
        setLoading(false);
      }
    }
  }, [selectedSpecialty, selectedDuration, selectedType, pageSize]);

  const handleSearchChange = useCallback(
    debounce((value) => {
      setCurrentPage(1);
      setAllVideos([]);
      getAllVideos(1, value, false);
    }, 500),
    []
  );

  const handleSpecialtyChange = (value) => {
    setSelectedSpecialty(value);
  };

  const handleDurationChange = (value) => {
    setSelectedDuration(value);
  };

  const handleTypeChange = (value) => {
    setSelectedType(value);
  };

  const handleLoadMore = useCallback(() => {
    const nextPage = currentPage + 1;
    getAllVideos(nextPage, searchText, true);
  }, [currentPage, searchText, getAllVideos]);

  const handleApplyFilters = useCallback(() => {
    setCurrentPage(1);
    setAllVideos([]);
    getAllVideos(1, searchText, false);
  }, [searchText, getAllVideos]);

  useEffect(() => {
    setCurrentPage(1);
    setAllVideos([]);
    getAllVideos(1, searchText, false);
  }, [getAllVideos, searchText]);




  return (
    <>
      {isModalOpen && (
        <VideoModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          videoSrc="https://storage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4"
          videoTitle={'Diabetes Management Basics'}
        />
      )}

      <VideosPageWrapper style={{ padding: '40px 60px' }}>
        <Row className="custom-header mb-24">
          <Col span={18} className="header-item">
            <CustomTitle>
              {activeTab === 'Videos' ? 'Video Library' : 'Scripts'}
            </CustomTitle>
            <CustomSubTitle>
              {activeTab === 'Videos'
                ? 'Browse our collection of medical education videos categorized by specialty.'
                : 'Create and manage your video scripts.'}
            </CustomSubTitle>
          </Col>
          <Col span={6} className="d-flex justify-content-end">
            <PhysicianPageWrapper>
              <Segmented
                options={[
                  {
                    label: (
                      <div style={{ padding: '8px 16px' }}>
                        <PlayCircleOutlined style={{ marginRight: '8px' }} />
                        <span>Videos</span>
                      </div>
                    ),
                    value: 'Videos',
                  },
                  {
                    label: (
                      <div style={{ padding: '8px 16px' }}>
                        <FileTextOutlined style={{ marginRight: '8px' }} />
                        <span>Scripts</span>
                      </div>
                    ),
                    value: 'Scripts',
                  },
                ]}
                value={activeTab}
                onChange={setActiveTab}
                style={{
                  fontSize: '16px',
                  background: 'var(--primary-bg)',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  borderRadius: '8px',
                  border: '1px solid var(--border-color)',
                }}
              />
            </PhysicianPageWrapper>
          </Col>
        </Row>

        {activeTab === 'Videos' ? (
          <Row gutter={16}>
            <FilterSidebar
              searchText={searchText}
              setSearchText={setSearchText}
              handleSearchChange={handleSearchChange}
              selectedSpecialty={selectedSpecialty}
              handleSpecialtyChange={handleSpecialtyChange}
              specialtyOptions={specialtyOptions}
              selectedType={selectedType}
              handleTypeChange={handleTypeChange}
              videoType={videoType}
              selectedDuration={selectedDuration}
              handleDurationChange={handleDurationChange}
              duration={duration}
              handleApplyFilters={handleApplyFilters}
              loading={loading}
            />
            <VideosSection
              allVideos={allVideos}
              videos={videos}
              hasMoreVideos={hasMoreVideos}
              handleLoadMore={handleLoadMore}
              loadMoreLoading={loadMoreLoading}
              loading={loading}
            />
          </Row>
        ) : (
          <ScriptsPage />
        )}
      </VideosPageWrapper>
    </>
  );
};

export default VideosPage;
